import { createApi, retry } from '@reduxjs/toolkit/query/react';
import { listaccountopeningbalancev2 } from '../../graphql';
import { baseQuery } from '../baseQuery';

const baseQueryWithRetry = retry(baseQuery, {
    maxRetries: 3,
    retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 30000),
});

export const listAccountOpeningBalanceApi = createApi({
    reducerPath: 'listAccountOpeningBalance',
    baseQuery: baseQueryWithRetry,
    tagTypes: ['listAccountOpeningBalance', 'allaccounts'],
    endpoints: (builder) => ({
        listAccountOpeningBalance: builder.query({
            query: (variables) => ({ body: listaccountopeningbalancev2, variables }),
            keepUnusedDataFor: 300,
            refetchOnMountOrArgChange: true,
            providesTags: ['listAccountOpeningBalance', 'allaccounts'],
            transformResponse: (response) => {
                if (!response) {
                    throw new Error('No data received');
                }
                return response;
            },
        }),
    }),
});

export const { useListAccountOpeningBalanceQuery } = listAccountOpeningBalanceApi;
